/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ProgramSessionSetData } from './program-session-set-data';

/**
 * 
 * @export
 * @interface ProgramSessionSet
 */
export interface ProgramSessionSet {
    /**
     * 
     * @type {number}
     * @memberof ProgramSessionSet
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'uuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProgramSessionSet
     */
    'programID'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'programName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProgramSessionSet
     */
    'sessionID'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'sessionName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProgramSessionSet
     */
    'exerciseID'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'exerciseUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'exerciseName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'exerciseGroup'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'reps'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'weight'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'rest'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'rir'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'rpe'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'setDate'?: string;
    /**
     * 
     * @type {ProgramSessionSetData}
     * @memberof ProgramSessionSet
     */
    'data'?: ProgramSessionSetData;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'status'?: ProgramSessionSetStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ProgramSessionSet
     */
    'authorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProgramSessionSet
     */
    'authorName'?: string;
}

export const ProgramSessionSetStatusEnum = {
    Todo: 'TODO',
    Done: 'DONE'
} as const;

export type ProgramSessionSetStatusEnum = typeof ProgramSessionSetStatusEnum[keyof typeof ProgramSessionSetStatusEnum];


